export default () => {
  const container = document.querySelector('.js-checkout-steps')
  const validateButton = document.querySelector('.js-checkout-button-validate')
  if (!validateButton) return
  const steps = document.querySelectorAll('.js-checkout-step-content')
  const prevButtons = [...document.querySelectorAll('.js-checkout-button-prev')]
  const errorMessage = document.querySelector('.js-checkout-error')
  const errorMessageHouseNumber = document.querySelector(
    '.js-checkout-error-number'
  )
  const errorMessageStreetName = document.querySelector(
    '.js-checkout-error-street'
  )
  const stepData = document.querySelector(`.js-checkout-step[data-step="1"]`);
  let index = 1

  sendDatalayer('begin_checkout', container.dataset.datalayer)
  sendDatalayer('add_shipping_info', container.dataset.datalayer)

  // Check field values
  ;[...steps].forEach(step => {
    if (step.classList.contains('active') && step.classList.contains('col-1')) {
      const nextButton = step.querySelector('.js-checkout-button-next')

      nextButton.addEventListener('click', function() {
        const billingFirstname = document.querySelector('#billing_first_name').value
        const billingLastname = document.querySelector('#billing_last_name').value
        const billingAddress = document.querySelector('#billing_address_1').value
        const billingPostcode = document.querySelector('#billing_postcode').value
        const billingCity = document.querySelector('#billing_city').value
        const billingPhone = document.querySelector('#billing_phone').value
        const billingMail = document.querySelector('#billing_email').value

        if (/\d/.test(billingAddress) && /[A-Za-z]+/.test(billingAddress)) {
          errorMessageHouseNumber.classList.remove('active')
          errorMessageStreetName.classList.remove('active')

          if (
            billingFirstname &&
            billingLastname &&
            billingAddress &&
            billingPostcode &&
            billingCity &&
            billingPhone &&
            billingMail
          ) {
            nextStep()
          } else {
            displayError()
          }
        } else {
          if (!/\d/.test(billingAddress)) {
            if (/[A-Za-z]+/.test(billingAddress)) {
              errorMessageStreetName.classList.remove('active')
            }
            displayErrorHouseNumber()
          }

          console.log(/[A-Za-z]+/.test(billingAddress))

          if (!/[A-Za-z]+/.test(billingAddress)) {
            if (/\d/.test(billingAddress)) {
              errorMessageHouseNumber.classList.remove('active')
            }
            displayErrorStreetName()
          }
        }
      })
    }
  })

  // Back to previous step
  ;[...prevButtons].forEach(button =>
    button.addEventListener('click', function() {
      const error = document.querySelector('.woocommerce-error')

      if (error) {
        error.style.display = 'none'
      }

      if (index > 1) {
        const currentCheckoutStep = document.querySelector(
          `.js-checkout-step-content[data-content="${index}"]`
        )

        const currentStep = document.querySelector(
          `.js-checkout-step[data-step="${index}"]`
        )

        index--

        const prevCheckoutStep = document.querySelector(
          `.js-checkout-step-content[data-content="${index}"]`
        )

        const prevStep = document.querySelector(
          `.js-checkout-step[data-step="${index}"]`
        )

        prevStep.classList.add('active')
        currentCheckoutStep.classList.remove('active')
        prevCheckoutStep.classList.add('active')
        currentStep.classList.remove('active')
      }

      index !== 1
        ? document
            .querySelector(`.c-woocommerce-notice`)
            .setAttribute('style', 'display:none;')
        : document
            .querySelector(`.c-woocommerce-notice`)
            .setAttribute('style', 'display:block;')
    })
  )

  // Functions
  function nextStep() {
    const currentIndex = index
    index++

    if (index === 2) {
      sendDatalayer('add_payment_info', container.dataset.datalayer)
      stepData.classList.remove('js-checkout-button-disabled')
    } else {
      if (!stepData.classList.contains('js-checkout-button-disabled')) stepData.classList.add('js-checkout-button-disabled');
    }

    const nextStep = document.querySelector(`.js-checkout-step[data-step="${index}"]`)
    const currentStep = document.querySelector(`.js-checkout-step[data-step="${currentIndex}"]`)
    const currentCheckoutStep = document.querySelector(`.js-checkout-step-content[data-content="${currentIndex}"]`)
    const nextCheckoutStep = document.querySelector(`.js-checkout-step-content[data-content="${index}"]`)

    if (!nextStep.classList.contains('active')) {
      currentCheckoutStep.classList.remove('active')
      currentStep.classList.remove('active')
      currentStep.classList.add('cart')
      nextStep.classList.add('active')
      nextCheckoutStep.classList.add('active')
      window.scrollTo(0, 0);
    }

    errorMessage.classList.contains('active')
      ? errorMessage.classList.remove('active')
      : ''

    index !== 1
      ? document
          .querySelector(`.c-woocommerce-notice`)
          .setAttribute('style', 'display:none;')
      : document
          .querySelector(`.c-woocommerce-notice`)
          .setAttribute('style', 'display:block;')
  }

  function displayError() {
    errorMessage.classList.add('active')
  }

  function displayErrorHouseNumber() {
    errorMessageHouseNumber.classList.add('active')
  }

  function displayErrorStreetName() {
    errorMessageStreetName.classList.add('active')
  }

  function sendDatalayer(event, data) {
    // Only send datalayer event once
    if (window.sessionStorage) {
      if (window.sessionStorage.getItem(event) === 'true') return

      window.dataLayer = window.dataLayer || []

      window.dataLayer.push({
        event: event,
        ecommerce: JSON.parse(data)
      })

      window.sessionStorage.setItem(event, 'true')
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/modules/CheckoutStepValidator.js